var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.609,
    height: 29.641,
    viewBox: "0 0 31.609 29.641",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#666;stroke:#666;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M29.738,0H1.812A1.331,1.331,0,0,0,.643.651a1.13,1.13,0,0,0,.1,1.266L10.977,15.1l.011.013a2.525,2.525,0,0,1,.574,1.586V27.439a1.144,1.144,0,0,0,.38.85,1.37,1.37,0,0,0,.927.352,1.455,1.455,0,0,0,.515-.094l5.749-2a1.15,1.15,0,0,0,.857-1.123V16.695a2.525,2.525,0,0,1,.574-1.586l.011-.013L30.8,1.917a1.129,1.129,0,0,0,.1-1.265A1.332,1.332,0,0,0,29.738,0ZM19.281,14.248a3.908,3.908,0,0,0-.882,2.447v8.547l-5.247,1.829V16.695a3.907,3.907,0,0,0-.883-2.447L2.336,1.454H29.214Zm0,0",
    transform: "translate(0.029 0.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.5b08ed34a61ac1c5c96510d69ef2100c.svg";
export { ForwardRef as ReactComponent };